/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_access_alarms } from './device/access_alarms.icon';
import { icon_access_time } from './device/access_time.icon';
import { icon_access_alarm } from './device/access_alarm.icon';
import { icon_add_alarm } from './device/add_alarm.icon';
import { icon_airplanemode_active } from './device/airplanemode_active.icon';
import { icon_airplanemode_inactive } from './device/airplanemode_inactive.icon';
import { icon_battery_20 } from './device/battery_20.icon';
import { icon_battery_60 } from './device/battery_60.icon';
import { icon_battery_30 } from './device/battery_30.icon';
import { icon_battery_50 } from './device/battery_50.icon';
import { icon_battery_80 } from './device/battery_80.icon';
import { icon_battery_90 } from './device/battery_90.icon';
import { icon_battery_charging_20 } from './device/battery_charging_20.icon';
import { icon_battery_charging_30 } from './device/battery_charging_30.icon';
import { icon_battery_alert } from './device/battery_alert.icon';
import { icon_battery_charging_80 } from './device/battery_charging_80.icon';
import { icon_battery_std } from './device/battery_std.icon';
import { icon_battery_charging_50 } from './device/battery_charging_50.icon';
import { icon_battery_charging_90 } from './device/battery_charging_90.icon';
import { icon_battery_charging_60 } from './device/battery_charging_60.icon';
import { icon_battery_charging_full } from './device/battery_charging_full.icon';
import { icon_battery_full } from './device/battery_full.icon';
import { icon_bluetooth } from './device/bluetooth.icon';
import { icon_bluetooth_connected } from './device/bluetooth_connected.icon';
import { icon_battery_unknown } from './device/battery_unknown.icon';
import { icon_brightness_high } from './device/brightness_high.icon';
import { icon_bluetooth_disabled } from './device/bluetooth_disabled.icon';
import { icon_brightness_auto } from './device/brightness_auto.icon';
import { icon_bluetooth_searching } from './device/bluetooth_searching.icon';
import { icon_brightness_low } from './device/brightness_low.icon';
import { icon_brightness_medium } from './device/brightness_medium.icon';
import { icon_data_usage } from './device/data_usage.icon';
import { icon_devices } from './device/devices.icon';
import { icon_dvr } from './device/dvr.icon';
import { icon_developer_mode } from './device/developer_mode.icon';
import { icon_gps_not_fixed } from './device/gps_not_fixed.icon';
import { icon_gps_fixed } from './device/gps_fixed.icon';
import { icon_gps_off } from './device/gps_off.icon';
import { icon_graphic_eq } from './device/graphic_eq.icon';
import { icon_location_disabled } from './device/location_disabled.icon';
import { icon_network_cell } from './device/network_cell.icon';
import { icon_network_wifi } from './device/network_wifi.icon';
import { icon_nfc } from './device/nfc.icon';
import { icon_location_searching } from './device/location_searching.icon';
import { icon_screen_lock_landscape } from './device/screen_lock_landscape.icon';
import { icon_sd_storage } from './device/sd_storage.icon';
import { icon_screen_lock_portrait } from './device/screen_lock_portrait.icon';
import { icon_screen_lock_rotation } from './device/screen_lock_rotation.icon';
import { icon_screen_rotation } from './device/screen_rotation.icon';
import { icon_settings_system_daydream } from './device/settings_system_daydream.icon';
import { icon_signal_cellular_3_bar } from './device/signal_cellular_3_bar.icon';
import { icon_signal_cellular_0_bar } from './device/signal_cellular_0_bar.icon';
import { icon_signal_cellular_1_bar } from './device/signal_cellular_1_bar.icon';
import { icon_signal_cellular_2_bar } from './device/signal_cellular_2_bar.icon';
import { icon_signal_cellular_4_bar } from './device/signal_cellular_4_bar.icon';
import { icon_signal_cellular_connected_no_internet_0_bar } from './device/signal_cellular_connected_no_internet_0_bar.icon';
import { icon_signal_cellular_connected_no_internet_1_bar } from './device/signal_cellular_connected_no_internet_1_bar.icon';
import { icon_signal_cellular_connected_no_internet_2_bar } from './device/signal_cellular_connected_no_internet_2_bar.icon';
import { icon_signal_cellular_null } from './device/signal_cellular_null.icon';
import { icon_signal_cellular_connected_no_internet_4_bar } from './device/signal_cellular_connected_no_internet_4_bar.icon';
import { icon_signal_cellular_no_sim } from './device/signal_cellular_no_sim.icon';
import { icon_signal_cellular_off } from './device/signal_cellular_off.icon';
import { icon_signal_wifi_0_bar } from './device/signal_wifi_0_bar.icon';
import { icon_signal_wifi_1_bar } from './device/signal_wifi_1_bar.icon';
import { icon_signal_cellular_connected_no_internet_3_bar } from './device/signal_cellular_connected_no_internet_3_bar.icon';
import { icon_signal_wifi_1_bar_lock } from './device/signal_wifi_1_bar_lock.icon';
import { icon_signal_wifi_2_bar } from './device/signal_wifi_2_bar.icon';
import { icon_signal_wifi_2_bar_lock } from './device/signal_wifi_2_bar_lock.icon';
import { icon_signal_wifi_3_bar_lock } from './device/signal_wifi_3_bar_lock.icon';
import { icon_signal_wifi_3_bar } from './device/signal_wifi_3_bar.icon';
import { icon_signal_wifi_4_bar } from './device/signal_wifi_4_bar.icon';
import { icon_storage } from './device/storage.icon';
import { icon_signal_wifi_off } from './device/signal_wifi_off.icon';
import { icon_signal_wifi_4_bar_lock } from './device/signal_wifi_4_bar_lock.icon';
import { icon_usb } from './device/usb.icon';
import { icon_widgets } from './device/widgets.icon';
import { icon_wallpaper } from './device/wallpaper.icon';
import { icon_wifi_lock } from './device/wifi_lock.icon';
import { icon_wifi_tethering } from './device/wifi_tethering.icon';
var icons = {
  "access_alarms" : icon_access_alarms,
"access_time" : icon_access_time,
"access_alarm" : icon_access_alarm,
"add_alarm" : icon_add_alarm,
"airplanemode_active" : icon_airplanemode_active,
"airplanemode_inactive" : icon_airplanemode_inactive,
"battery_20" : icon_battery_20,
"battery_60" : icon_battery_60,
"battery_30" : icon_battery_30,
"battery_50" : icon_battery_50,
"battery_80" : icon_battery_80,
"battery_90" : icon_battery_90,
"battery_charging_20" : icon_battery_charging_20,
"battery_charging_30" : icon_battery_charging_30,
"battery_alert" : icon_battery_alert,
"battery_charging_80" : icon_battery_charging_80,
"battery_std" : icon_battery_std,
"battery_charging_50" : icon_battery_charging_50,
"battery_charging_90" : icon_battery_charging_90,
"battery_charging_60" : icon_battery_charging_60,
"battery_charging_full" : icon_battery_charging_full,
"battery_full" : icon_battery_full,
"bluetooth" : icon_bluetooth,
"bluetooth_connected" : icon_bluetooth_connected,
"battery_unknown" : icon_battery_unknown,
"brightness_high" : icon_brightness_high,
"bluetooth_disabled" : icon_bluetooth_disabled,
"brightness_auto" : icon_brightness_auto,
"bluetooth_searching" : icon_bluetooth_searching,
"brightness_low" : icon_brightness_low,
"brightness_medium" : icon_brightness_medium,
"data_usage" : icon_data_usage,
"devices" : icon_devices,
"dvr" : icon_dvr,
"developer_mode" : icon_developer_mode,
"gps_not_fixed" : icon_gps_not_fixed,
"gps_fixed" : icon_gps_fixed,
"gps_off" : icon_gps_off,
"graphic_eq" : icon_graphic_eq,
"location_disabled" : icon_location_disabled,
"network_cell" : icon_network_cell,
"network_wifi" : icon_network_wifi,
"nfc" : icon_nfc,
"location_searching" : icon_location_searching,
"screen_lock_landscape" : icon_screen_lock_landscape,
"sd_storage" : icon_sd_storage,
"screen_lock_portrait" : icon_screen_lock_portrait,
"screen_lock_rotation" : icon_screen_lock_rotation,
"screen_rotation" : icon_screen_rotation,
"settings_system_daydream" : icon_settings_system_daydream,
"signal_cellular_3_bar" : icon_signal_cellular_3_bar,
"signal_cellular_0_bar" : icon_signal_cellular_0_bar,
"signal_cellular_1_bar" : icon_signal_cellular_1_bar,
"signal_cellular_2_bar" : icon_signal_cellular_2_bar,
"signal_cellular_4_bar" : icon_signal_cellular_4_bar,
"signal_cellular_connected_no_internet_0_bar" : icon_signal_cellular_connected_no_internet_0_bar,
"signal_cellular_connected_no_internet_1_bar" : icon_signal_cellular_connected_no_internet_1_bar,
"signal_cellular_connected_no_internet_2_bar" : icon_signal_cellular_connected_no_internet_2_bar,
"signal_cellular_null" : icon_signal_cellular_null,
"signal_cellular_connected_no_internet_4_bar" : icon_signal_cellular_connected_no_internet_4_bar,
"signal_cellular_no_sim" : icon_signal_cellular_no_sim,
"signal_cellular_off" : icon_signal_cellular_off,
"signal_wifi_0_bar" : icon_signal_wifi_0_bar,
"signal_wifi_1_bar" : icon_signal_wifi_1_bar,
"signal_cellular_connected_no_internet_3_bar" : icon_signal_cellular_connected_no_internet_3_bar,
"signal_wifi_1_bar_lock" : icon_signal_wifi_1_bar_lock,
"signal_wifi_2_bar" : icon_signal_wifi_2_bar,
"signal_wifi_2_bar_lock" : icon_signal_wifi_2_bar_lock,
"signal_wifi_3_bar_lock" : icon_signal_wifi_3_bar_lock,
"signal_wifi_3_bar" : icon_signal_wifi_3_bar,
"signal_wifi_4_bar" : icon_signal_wifi_4_bar,
"storage" : icon_storage,
"signal_wifi_off" : icon_signal_wifi_off,
"signal_wifi_4_bar_lock" : icon_signal_wifi_4_bar_lock,
"usb" : icon_usb,
"widgets" : icon_widgets,
"wallpaper" : icon_wallpaper,
"wifi_lock" : icon_wifi_lock,
"wifi_tethering" : icon_wifi_tethering,
};
export { icons };
